import { render, staticRenderFns } from "./_by-loja-v2.table.vue?vue&type=template&id=69a609a3&scoped=true"
import script from "./_by-loja-v2.table.vue?vue&type=script&lang=js"
export * from "./_by-loja-v2.table.vue?vue&type=script&lang=js"
import style0 from "./_by-loja-v2.table.vue?vue&type=style&index=0&id=69a609a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a609a3",
  null
  
)

export default component.exports